"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = _interopRequireDefault(require("../Input/Input"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _useLabel = _interopRequireDefault(require("../../hooks/useLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable no-unused-vars */
const InputPlaceGoogle = props => {
  const {
    apiKey,
    label: initialLabel,
    id: controlledId,
    value: controlledValue,
    onChange,
    ...attributes
  } = props;
  const id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  const [query, setQuery] = (0, _react.useState)('');
  const [value, setValue] = (0, _react.useState)(controlledValue);
  const googleMapScript = (0, _react.useRef)();
  const googleInputRef = /*#__PURE__*/(0, _react.createRef)();
  const {
    label
  } = (0, _useLabel.default)(initialLabel, {
    ...props
  });
  _react.default.useEffect(() => setValue(controlledValue || ''), [controlledValue]);
  googleMapScript.current = document.getElementById('googleMapScript');
  if (googleMapScript.current == null) {
    googleMapScript.current = document.createElement('script');
    googleMapScript.current.setAttribute('id', 'googleMapScript');
    googleMapScript.current.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&libraries=places";
    document.body.appendChild(googleMapScript.current);
  }
  (0, _react.useEffect)(() => {
    googleInputRef.current = document.getElementById(id);
    if (query === 'none' && typeof onChange === 'function') {
      setValue('');
      onChange({});
    }
    if (window && window.google && query.length) {
      const autocomplete = new window.google.maps.places.Autocomplete(googleInputRef.current);
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          return;
        }
        if (place.geometry.viewport) {
          setValue(place.formatted_address);
          if (typeof onChange === 'function') {
            onChange(place);
          }
        }
      });
    }
  }, [googleInputRef, query, id, onChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-map"
  }, label, /*#__PURE__*/_react.default.createElement(_Input.default, _extends({
    value: value,
    onChange: e => setQuery(e || 'none'),
    id: id
  }, attributes)));
};

// const InputPlaceOS = ({ id: controlledId, ...attributes }) => {
//     const id = React.useRef(useRandomId(controlledId)).current;

//     useEffect(() => {
//         // eslint-disable-next-line global-require
//         const places = require('places.js');
//         const placesAutocomplete = places({
//             appId: 'plZ4MI084IZ7',
//             apiKey: '0894210c0f0da2cc24b66e46df4fefc3',
//             container: document.getElementById(id),
//         });
//     });

//     return <Input id={id} {...attributes} />;
// };

/**
 * The InputPlace component allows an user to enter an auto-formatted address into the application.
 */
const InputPlace = props => {
  const {
    label: initialLabel
  } = props;
  // const { apiKey } = props;
  // if (apiKey) return <InputPlaceGoogle {...props} />;
  // return <InputPlaceOS {...props} />;

  const {
    label
  } = (0, _useLabel.default)(initialLabel, {
    ...props
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-map"
  }, label, /*#__PURE__*/_react.default.createElement(InputPlaceGoogle, props));
};
InputPlace.propTypes = {
  /**
   * Google API client key to enable the Place library.
   */
  apiKey: _propTypes.default.string,
  /**
   * ID of the InputPlace (used to bind the label to the InputPlace)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Name of the InputPlace (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,
  /**
   * Type of the InputPlace
   */
  type: _propTypes.default.oneOf(['email', 'number', 'password', 'search', 'tel', 'text']),
  /**
   * Default value of the InputPlace
   * Form-validation: set validation rules depending of type
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * Label of the InputPlace
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * InputPlace placeholder
   */
  placeholder: _propTypes.default.string,
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Remove the placeholder (if any), replace it with a floating label
   */
  floatLabel: _propTypes.default.bool,
  /**
   * Add a button to clear the InputPlace
   */
  clearable: _propTypes.default.bool,
  /**
   * Set the InputPlace as read-only
   */
  readOnly: _propTypes.default.bool,
  /**
   * Set the InputPlace as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Form-validation: set the InputPlace as required
   */
  required: _propTypes.default.bool,
  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onInputPlace
   */
  onInput: _propTypes.default.func,
  /**
   * Callback function onBlur
   */
  onBlur: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,
  /**
   * Add an icon
   */
  icon: _propTypes.default.string,
  /**
   * Position the icon relative to the InputPlace element
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  /**
   * Add an informative box next to the input element
   */
  addon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Position the info relative to the input element
   */
  addonPosition: _propTypes.default.oneOf(['left', 'right']),
  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string
};
InputPlace.defaultProps = {
  type: 'text',
  placeholder: '',
  helper: '',
  floatLabel: false,
  readOnly: false,
  clearable: false,
  disabled: false,
  required: false,
  icon: '',
  iconPosition: 'right',
  addonPosition: 'right'
};
var _default = exports.default = InputPlace;